var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 7.19995C10.4998 7.19995 10.2998 7.09995 10.0998 6.89995C9.8998 6.69995 9.7998 6.49995 9.7998 6.19995C9.7998 5.69995 10.1998 5.19995 10.7998 5.19995C11.3998 5.19995 11.7998 5.59995 11.7998 6.19995C11.7998 6.79995 11.2998 7.19995 10.7998 7.19995Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.4H3.3C2.9 14.4 2.5 14.1 2.5 13.6V11.4C2.5 11.2 2.6 11 2.7 10.9L6.2 7.4C5.8 5.8 6.2 4.1 7.4 2.9C8.3 2 9.4 1.5 10.7 1.5C11.9 1.5 13.1 2 14 2.9C15.8 4.7 15.8 7.7 14 9.5C12.8 10.7 11.1 11.1 9.5 10.7L6 14.2C5.9 14.3 5.7 14.4 5.5 14.4ZM4.1 12.9H5.2L8.8 9.3C9 9.1 9.3 9 9.6 9.2C10.8 9.7 12.1 9.4 13 8.5C14.2 7.3 14.2 5.3 13 4C12.4 3.4 11.6 3.1 10.8 3.1C9.9 3.1 9.1 3.4 8.6 4C7.7 4.9 7.4 6.2 7.8 7.4C8 7.6 7.9 8 7.7 8.2L4.1 11.8V12.9Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.53466f2aae2dc1f40cbd2a0655810de6.svg";
export { ForwardRef as ReactComponent };